<template>
    <menu_items :menu_items="menu_items"
          initial_item="acute_toxicity"
    />
</template>

<script>

import menu_items from '../../components/menu.vue';
import eye_injury from './_3_eye_injury/index';
import mutagenicity from './_9_mutagenicity/index';
import acute_toxicity from './_1_acute_toxicity/index';
import carcinogenicity from './_6_carcinogenicity/index';
import aspiration_hazard from './_7_aspiration_hazard/index';
import skin_sensitization from './_5_skin_sensitization/index';
import reproductive_toxicity from './_8_reproductive_toxicity/index';
import respiratory_sensitization from './_4_respiratory_sensitization/index';
import corrosion_skin_irritation from './_2_corrosion_skin_irritation/index';
import specific_organ_toxicity_single_exposure from './_10_specific_organ_toxicity_single_exposure/index';
import specific_organ_toxicity_repeated_exposure from './_11_specific_organ_toxicity_repeated_exposure/index';

export default {
    name: 'index',
    components: {
        menu_items,
        eye_injury,
        mutagenicity,
        acute_toxicity,
        carcinogenicity,
        aspiration_hazard,
        skin_sensitization,
        reproductive_toxicity,
        corrosion_skin_irritation,
        respiratory_sensitization,
        specific_organ_toxicity_single_exposure,
        specific_organ_toxicity_repeated_exposure
    },
    data() {
        return {
            menu_items: [
                {
                    name: 'acute_toxicity',
                    text: 'Toxicidad aguda',
                    component: acute_toxicity,
                    image: 'CALAVERA_Y_TIBIAS_CRUZADAS_SIGNO_DE_EXCLAMACION.png'
                },
                {
                    name: 'corrosion_skin_irritation',
                    text: 'Corrosión e irritación cutánea',
                    component: corrosion_skin_irritation,
                    image: 'CORROSION_SIGNO_DE_EXCLAMACION.png'
                },
                {
                    name: 'eye_injury',
                    text: 'Lesiones oculares graves/irritación ocular',
                    component: eye_injury,
                    image: 'CORROSION_SIGNO_DE_EXCLAMACION.png'
                },
                {
                    name: 'respiratory_sensitization',
                    text: 'Sensibilización respiratoria',
                    component: respiratory_sensitization,
                    image: 'PELIGRO_PARA_LA_SALUD.png'
                },
                {
                    name: 'skin_sensitization',
                    text: 'Sensibilización cutánea',
                    component: skin_sensitization,
                    image: 'SIGNO_DE_EXCLAMACION.png'
                },
                {
                    name: 'mutagenicity',
                    text: 'Mutagenicidad',
                    component: mutagenicity,
                    image: 'PELIGRO_PARA_LA_SALUD.png'
                },
                {
                    name: 'carcinogenicity',
                    text: 'Carcinogenicidad',
                    component: carcinogenicity,
                    image: 'PELIGRO_PARA_LA_SALUD.png'
                },
                {
                    name: 'reproductive_toxicity',
                    text: 'Toxicidad para la reproducción',
                    component: reproductive_toxicity,
                    image: 'PELIGRO_PARA_LA_SALUD.png'
                },
                {
                    name: 'specific_organ_toxicity_single_exposure',
                    text: 'Toxicidad especifica de órganos Diana - Exposición única',
                    component: specific_organ_toxicity_single_exposure,
                    image: 'PELIGRO_PARA_LA_SALUD_SIGNO DE EXCLAMACION.png'
                },
                {
                    name: 'specific_organ_toxicity_repeated_exposure',
                    text: 'Toxicidad especifica de órganos Diana - Exposiciones repetidas',
                    component: specific_organ_toxicity_repeated_exposure,
                    image: 'PELIGRO_PARA_LA_SALUD.png'
                },
                {
                    name: 'aspiration_hazard',
                    text: 'Peligros por aspiración',
                    component: aspiration_hazard,
                    image: 'PELIGRO_PARA_LA_SALUD.png'
                }
            ],
        };
    }
};
</script>
